<div class="nav-container" [class.is-mobile]="mobileQuery.matches">

   <button *ngIf="mobileQuery.matches" (click)="nav.toggle()"
           class="h-10 ml-5">
      <img src="assets/img/icons/Icona-hamburger-menu.svg" alt="" class="svg-black">

   </button>

   <button *ngIf="!isShowing && !mobileQuery.matches" (click)="toggleSidenav()"
           class="relative ml-5 mt-2">
      <img src="assets/img/icons/Icona-hamburger-menu.svg" class="svg-black" alt="">
   </button>

   <mat-sidenav-container class="side-nav">

      <mat-sidenav #nav
                   [mode]="mobileQuery.matches ? 'over' : 'side'"
                   [opened]="!mobileQuery.matches && isShowing"
                   [fixedInViewport]="mobileQuery.matches" fixedTopGap="64">

         <section>
            <ng-container *ngTemplateOutlet="header"></ng-container>

            <div class="justify-between">

               <div class="p-5 text-white font-bold flex justify-between">
                  <div class="self-center">
                     <svg width="56" height="13" viewBox="0 0 56 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.098 10.912H14.384L20.918 2.56V0.436H12.008V2.524H18.2L11.684 10.876V13H21.098V10.912ZM31.6914 13V10.894H25.7874V7.69H31.0074V5.584H25.7874V2.542H31.6914V0.436H23.4114V13H31.6914ZM41.7444 13H44.3544V0.436H42.1044V9.49H42.0504L40.7544 6.88L36.9744 0.436H34.3644V13H36.6144V3.946H36.6684L37.9644 6.556L41.7444 13ZM55.9579 2.542V0.436H46.4539V2.542H50.0179V13H52.3939V2.542H55.9579Z" fill="#BCD31E"/>
                        <path d="M5.34958 4.18513L7.93055 1.58036L7.43335 1.07881L4.85238 3.68239V0H4.14879V3.68239L1.56664 1.07881L1.06945 1.58036L3.65042 4.18513H0V4.89487H3.65042L1.06945 7.49845L1.56664 8L4.50059 5.04155L7.43335 8L7.93055 7.49845L5.34958 4.89487H9V4.18513H5.34958Z" fill="#CCE10F"/>
                     </svg>
                  </div>
                  <div>
                     <button (click)="toggleSidenav()">
                        <img src="assets/img/icons/Icona-hamburger-menu.svg" alt="">

                     </button>
                  </div>
               </div>

            </div>
            <div class="badge badge-error ml-3" *ngIf="dataSrv.user.IsAdmin">
               admin
            </div>

         </section>

         <mat-nav-list class="pb-20">

            <section *ngFor="let el of elements; let i = index">

               <a mat-list-item [routerLink]="el?.routerLink!" [routerLinkActive]="el?.routerLinkActive!"
                  *ngIf="!el?.children?.length && !el?.hide_element" class="font-bold child_item">
                  <ng-container *ngTemplateOutlet="elName; context:{element: el, index:i}"></ng-container>
               </a>

               <mat-divider *ngIf="el?.show_divider && !el?.children?.length" class="mt-2"></mat-divider>
               <mat-accordion>

                  <mat-expansion-panel (opened)="onPanelOpened(i)" [expanded]="isPanelExpanded[i]" *ngIf="el?.children?.length! > 0 && !el?.hide_element">

                     <mat-expansion-panel-header [ngClass]="el.has_badge_name ? 'mb-3' : ''">
                        <mat-panel-title class="font-bold">
                           <ng-container *ngTemplateOutlet="elName;context:{element: el, index:i}"></ng-container>
                        </mat-panel-title>
                     </mat-expansion-panel-header>

                     <mat-divider *ngIf="el?.show_divider"></mat-divider>

                     <section *ngFor="let c of el.children">
                        <a mat-list-item *ngIf="!c.hide_element" class="child_item"
                           [routerLink]="c?.routerLink!" [routerLinkActive]="c?.routerLinkActive!">
                           <ng-container *ngTemplateOutlet="elName;context:{element: c, index:i}"></ng-container>
                           <span *ngIf="c?.has_contract_badge"><span class="ml-20"><span class="h-[15px] w-[15px] bg-red-600 rounded-2xl inline-block animate-bounce"></span></span></span>
                        </a>
                     </section>
                  </mat-expansion-panel>
               </mat-accordion>

               <mat-divider *ngIf="el.has_badge_name"></mat-divider>

            </section>

            <section *ngIf="footer">
               <ng-container *ngTemplateOutlet="footer"></ng-container>
            </section>

         </mat-nav-list>

         <footer style="position: fixed; bottom: 0; height: 60px; background: #191919; width: 249px;">
            <div class="flex mt-3">
               <div class="flex-1 text-white ml-2 overflow-hidden align-middle self-center">
                  <a [routerLink]="['../../esercizi']">
                     {{dataSrv.user.data.email}}
                  </a>
               </div>
               <div class="flex-1 justify-center text-center">
                  <button [mat-dialog-close]="true" cdkFocusInitial
                          class="ds-btn ds-btn-sm ds-btn-info justify-center"
                          (click)="serverSrv.logout()">
                     Esci
                  </button>
               </div>
            </div>
         </footer>
      </mat-sidenav>

      <mat-sidenav-content>
         <div class="h-full">
            <router-outlet></router-outlet>
         </div>
      </mat-sidenav-content>
   </mat-sidenav-container>

</div>

<ng-template #elName let-element="element" let-index="index">
   <span class="mr-2" *ngIf="element.has_badge_name">

      <div class="circle" [ngStyle]="{'background-color':circleElements[index - 1].color}">{{element.name | shortName}}</div>
   </span>

   <section *ngIf="!element.has_badge">
      {{element.name}}
   </section>

   <section *ngIf="element.has_badge" class="badge_custom_container">
       <span matBadge='{{badgeSrv.badgeCount!}}' class="badge_custom"
             [matBadgeHidden]='badgeSrv.badgeCount! <= 0'
             matBadgeOverlap='false'>{{element.name}}</span>
   </section>

   <section *ngIf="element.has_contract_badge && !dataSrv.esercizioUser.esercizio.data.documento_contratto" class="">
      <span><span class="ml-32"><span class="h-[15px] w-[15px] bg-red-600 rounded-2xl inline-block"></span></span></span>
   </section>

</ng-template>


